// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"cloud"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 15C2 17.2091 3.79086 19 6 19H17C19.7614 19 22 16.7614 22 14C22 11.2386 19.7614 9 17 9C16.9723 9 16.9447 9.00023 16.9172 9.00067C16.4414 6.16263 13.9732 4 11 4C7.68629 4 5 6.68629 5 10C5 10.3762 5.03463 10.7444 5.10088 11.1015C3.3247 11.5094 2 13.1 2 15Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 15C2 17.2091 3.79086 19 6 19H17C19.7614 19 22 16.7614 22 14C22 11.2386 19.7614 9 17 9C16.9723 9 16.9447 9.00023 16.9172 9.00067C16.4414 6.16263 13.9732 4 11 4C7.68629 4 5 6.68629 5 10C5 10.3762 5.03463 10.7444 5.10088 11.1015C3.3247 11.5094 2 13.1 2 15Z","strokeWidth":"props.strokeWidth"}}]}]};

const CloudIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cloud',
    ref,
    icon: element,
  },
));

CloudIcon.displayName = 'CloudIcon';

export default CloudIcon;
